import React from 'react'
import css from './NewPage.module.scss'
const Neruhomist = () => {
  return (
    <>
         <h2 className={css.title}>Сторона фізична особа:</h2>
              <p className={css.text}>
          1.    Паспорт; <br /> 
2.    Реєстраційний номер облікової картки платника податків; <br />
3.    Якщо нерухомість придбавалась в період шлюбу – згода одного з подружжя на відчуження майна;<br />
4.    Якщо покупець у шлюбі – згода одного з подружжя на придбання майна;
          </p> 
          <p className={css.text}>
                 Якщо однією зі сторін є неповнолітня особа (до 18 років) або в квартирі/будинку, що відчужується, зареєстрований неповнолітній, то відчуження відбувається за згодою органів опіки та піклування. Якщо особа не досягла 14 років (малолітня особа), то замість неї договір підписують батьки. Якщо підписантом є неповнолітня особа віком від 14 до 18 років, то вона самостійно підписує договір, але за згодою батьків. Підписи батьків на згоді повинні бути засвідчені нотаріально - див. Засвідчення справжності підпису на заявах.
          </p>
           <h2 className={css.title}>Сторона юридична особа:</h2>
     <p className={css.text}>
                -    Виписка з Єдиного державного реєстру юридичних осіб та фізичних осіб-підприємців (свідоцтво про державну реєстрацію);<br />
-    Витяг з Єдиного державного реєстру юридичних осіб та фізичних осіб-підприємців (місячної давності);<br />
-    Статут;<br />
-    Довідка з ЄДРПОУ (видається органами статистики);<br />
-    Протокол/рішення, наказ про призначення посадової особи, яка уповноважена за статутом діяти без довіреності;<br />
-    Якщо від імені юридичної особи діє представник, уповноважений за довіреністю – посвідчена нотаріально довіреність;<br />
-    Якщо діє від імені юридичної особи керівник філії (відділення) – додатково аналогічний перелік документів по філії (відділенню);<br />
-    Якщо укладення такого характеру договорів згідно статуту юридичної особи здійснюється зі згоди вищого органу – протокол загальних зборів вищого органу, в якому представнику юридичної особи надано згоду на укладення договору;<br />
-    Паспорт підписанта;<br />
-    Печатка юридичної особи.<br />
          </p>
          <h2 className={css.title}>Для купівлі-продажу квартири:</h2>
          <p className={css.text}>
              - Правовстановлюючий документ на квартиру<br />
              – Свідоцтво про право власності / Договір дарування/ Договір купівлі-продажу / Свідоцтво про право на спадщину та ін. зі штампом про реєстрацію в БТІ, або з реєстраційним посвідченням, що підтверджує реєстрацію в БТІ, або з Витягом про реєстрацію права власності на нерухоме майно в БТІ;<br />
- Витяг з Державного реєстру речових прав на нерухоме майно про реєстрацію права власності; <br />
- Довідка Ф-3 (про склад зареєстрованих в квартирі осіб), видана ЖЕК/ кооперативом/ ОСББ або довідка про відсутність зареєстрованих;<br />
- Експертна оцінка ринкової вартості квартири, замовлена у цілях оподаткування із ідентифікатором у базі ФДМУ;<br />
- Якщо квартира перебуває у спільній власності декількох осіб – згода співвласника на продаж. <br />
               </p>
      </>
  )
}

export default Neruhomist
